const STORAGE_KEY = 'tk-wishlist';

function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function isInWishlist(productId, variantId) {
  return getWishlist().some((item) => {
    if (variantId && item.variantId) {
      return String(item.variantId) === String(variantId);
    }
    return String(item.id || item) === String(productId);
  });
}

function findInWishlist(productId, variantId) {
  return getWishlist().find((item) => {
    if (variantId && item.variantId) {
      return String(item.variantId) === String(variantId);
    }
    return String(item.id || item) === String(productId);
  });
}

function toggleWishlist(productId, productData) {
  const id = String(productId);
  const variantId = productData && productData.variantId ? String(productData.variantId) : null;
  let list = getWishlist();
  const index = list.findIndex((item) => {
    if (variantId && item.variantId) {
      return String(item.variantId) === String(variantId);
    }
    return String(item.id || item) === id;
  });
  let added;

  if (index > -1) {
    list.splice(index, 1);
    added = false;
  } else {
    list.push(
      productData || {
        id,
        handle: '',
        title: '',
        image: '',
        price: '',
        url: '',
      }
    );
    added = true;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { productId: id, variantId, list } }));
  updateHeaderCount(list.length);
  return added;
}

function updateHeaderCount(count) {
  document.querySelectorAll('.tk-wishlist-count').forEach(function(badge) {
    badge.textContent = count;
    badge.hidden = count === 0;
  });
  document.querySelectorAll('.tk-header__mob-icon--wishlist').forEach(function(el) {
    el.classList.toggle('has-items', count > 0);
  });
}

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.variantId = this.dataset.variantId || null;
    this.updateState();
    this.addEventListener('click', this.handleClick.bind(this));
    this._onChange = this.handleChange.bind(this);
    window.addEventListener('wishlist:change', this._onChange);

    this._onVariantUpdate = this.handleVariantUpdate.bind(this);
    const scope = this.closest('.shopify-section, product-card');
    if (scope) {
      this._variantScope = scope;
      scope.addEventListener('variant:update', this._onVariantUpdate);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('wishlist:change', this._onChange);
    if (this._variantScope) {
      this._variantScope.removeEventListener('variant:update', this._onVariantUpdate);
      this._variantScope = null;
    }
  }

  handleVariantUpdate(e) {
    const resource = e.detail && e.detail.resource;
    if (!resource) return;

    this.variantId = String(resource.id);
    this.dataset.variantId = this.variantId;

    if (resource.price != null) {
      const formatted = (resource.price / 100).toLocaleString('cs-CZ') + '\u00a0Kč';
      this.dataset.price = formatted;
    }

    const variantTitle = resource.title && resource.title !== 'Default Title' ? resource.title : '';
    this.dataset.variantTitle = variantTitle;

    if (resource.url) {
      this.dataset.url = resource.url;
    } else {
      const baseUrl = this.dataset.url ? this.dataset.url.split('?')[0] : '';
      if (baseUrl) {
        this.dataset.url = baseUrl + '?variant=' + resource.id;
      }
    }

    requestAnimationFrame(() => {
      const galleryImg = this.getGalleryImage();
      if (galleryImg) this.dataset.image = galleryImg;
    });

    this.updateState();
  }

  getGalleryImage() {
    const card = this.closest('product-card, .product-card');
    if (card) {
      let img = null;
      if (this.variantId) {
        img = card.querySelector('slideshow-slide[slide-id="variant-meta-' + this.variantId + '"] img');
      }
      if (!img) {
        img = card.querySelector('slideshow-slide:first-child img');
      }
      return img ? img.src : null;
    }
    const section = this.closest('.shopify-section');
    if (section) {
      const img = section.querySelector('media-gallery slideshow-slides slideshow-slide:first-child img');
      return img ? img.src : null;
    }
    return null;
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    let image = this.dataset.image || '';
    const galleryImg = this.getGalleryImage();
    if (galleryImg) image = galleryImg;

    const data = {
      id: String(this.productId),
      variantId: this.variantId ? String(this.variantId) : null,
      handle: this.dataset.handle || '',
      title: this.dataset.title || '',
      variantTitle: this.dataset.variantTitle || '',
      image,
      price: this.dataset.price || '',
      url: this.dataset.url || '',
    };

    const added = toggleWishlist(this.productId, data);
    this.classList.toggle('is-active', added);

    const svg = this.querySelector('svg');
    if (svg) {
      svg.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], {
        duration: 300,
        easing: 'ease-out',
      });
    }
  }

  handleChange(e) {
    const detail = e.detail;
    if (this.variantId && detail.variantId) {
      if (String(detail.variantId) === String(this.variantId)) {
        this.updateState();
      }
    } else if (String(detail.productId) === String(this.productId)) {
      this.updateState();
    }
  }

  updateState() {
    this.classList.toggle('is-active', isInWishlist(this.productId, this.variantId));
  }
}

customElements.define('wishlist-button', WishlistButton);

window.MoWishlist = { getWishlist, isInWishlist, toggleWishlist, updateHeaderCount };
